module.exports = __webpack_public_path__ + "static/media/filter-footer.9a989233.png";